import { render, staticRenderFns } from "./TableModels.vue?vue&type=template&id=4b3e9591&scoped=true"
import script from "./TableModels.js?vue&type=script&lang=js&external"
export * from "./TableModels.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3e9591",
  null
  
)

export default component.exports